import forEach from 'lodash/forEach'
import get from 'lodash/get'

import RegistrationView from './components/RegistrationView.vue'
import DonationView from './components/DonationView.vue'
import HomeView from './components/HomeView.vue'
import CampaignDashboardView from './components/CampaignDashboardView.vue'
import LoginView from './components/LoginView.vue'
import CampaignFundRaisingView from './components/CampaignFundRaisingView.vue'
import CampaignDetailView from './components/CampaignDetailView.vue'
import RunnerProfileDashboardView from './components/RunnerProfileDashboardView.vue'

import EventBus from './eventBus'

window.onload = (e) => {
    new Vue({
        el: '#app',
        delimiters: ["<%","%>"],
        components: {
            RegistrationView,
            HomeView,
            DonationView,
            CampaignDashboardView,
            LoginView,
            CampaignFundRaisingView,
            CampaignDetailView,
            RunnerProfileDashboardView,
        },
        data() {
            return {
                globalVars: {},
                navSticky: false,
                mobileMenuOpen: false,
                navH: 0,
                vw: 0,
                vh: 0,
                desktopActiveItem: 0,
                mobileToggleMenuItems: 0,
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('resize', this.handleResize)
            this.syncGlobalVars()
            this.navH = this.$refs.nav.offsetHeight
            this.updateViewport()
        },
        computed: {
            
        },
        methods: {
            syncGlobalVars() {
                this.globalVars = globalVars
            },
            handleScroll() {
                this.navSticky = (window.scrollY > 250)
            },
            handleResize() {
                this.updateViewport()
            },
            updateViewport() {
                this.vw = window.innerWidth
                this.vh = window.innerHeight
            },
            resetDesktopActiveItem() {
                this.desktopActiveItem = 0
            },
            toggleMobileMenu(num) {
                this.mobileToggleMenuItems = (this.mobileToggleMenuItems === num) ? 0 : num
            },
        },
        watch: {
            
        },
    })
}